<template>
  <div class="boundEnterprise">
    <div
      class="boundEnterprise_tip"
      v-if="companyList.length!==0"
    >已绑定企业</div>
    <div
      v-for="e in companyList"
      class="company"
      :key="e.id"
    >
      <div class="corpNameInfoBox">
        <div class="companyName">{{e.corpName}}</div>
        <div class="companyInfo">
          <div class="name">{{e.userTypeDesc}}</div>
          <div class="type" @click="update(e)">名称变更</div>
          <div class="type" @click="clickHandler(e)">经营数据</div>
        </div>
      </div>
      <i class="iconfont icon-you "></i>
    </div>
    <UpdatePopover
      v-model="isPopover"
      @onSubmit="onSubmit"
      :corpName="curCorp.corpName"
    />
  </div>
</template>

<script>
import { Toast } from 'vant';
import UpdatePopover from './UpdatePopover/index.vue';
import { mapState, mapMutations } from 'vuex';

export default {
  name: 'boundEnterprise',
  data() {
    return {
      isPopover: false,
      curCorp:{},
    };
  },
  mounted() {
  },
  components:{
    UpdatePopover
  },
  props: ['companyList'],
  computed: {
    ...mapState({
      publicPage(val) {
        return val.publicPage;
      },
    }),
  },
  methods: {
    ...mapMutations('publicPage', ['updateState']),
    async onSubmit(corpName) {
      const {userType, corpId} = this.curCorp
      const res = await this.$api.PublicPage.updateCorpName({userType, corpId, corpName})
      if(!res.success){
        return Toast(res.returnMessage);
      }
      Toast('企业名称变更成功');
      this.$emit('getList')
      this.isPopover = false;
    },
    update(e) {
      this.isPopover = true;
      this.curCorp = e
    },
    clickHandler({
      taxNo,
      userName,
      identity,
      corpName,
      productId,
    }) {
      this.$router.push({
        path: '/supermarket/v2/dataAcquisition',
        query: {
          statusCode: 2,
          redirect: encodeURIComponent('/supermarket/v2/bindEnterprise'),
          taxNo,
          name: userName,
          identity,
          corpName,
          productId,
        },
      });
    },
  },
};
</script>
<style scoped>
.company {
  margin: 0 16px 16px 16px;
  background: #fff;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding: 12px;
  box-shadow: 0 4px 8px 0 rgba(0, 31, 51, 0.08);
  border-radius: 3px;
}
.companyName {
  font-family: PingFangSC-Medium;
  font-size: 15px;
  color: #001f33;
}
.name {
  font-family: PingFangSC-Regular;
  font-size: 14px;
  color: #bcc2cc;
  margin-right: 8px;
}
.corpNameInfoBox {
  width: 100%;
  text-align: left;
}
.type {
  font-family: PingFangSC-Regular;
  font-size: 14px;
  color: #ff6538;
  font-weight: 400;
  cursor: pointer;
}
.companyInfo {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin-top: 8px;
  margin-right: 30px;
}
.boundEnterprise_tip {
  text-align: left;
  font-family: PingFangSC-Regular;
  font-size: 14px;
  color: #505659;
  letter-spacing: 0;
  padding: 12px 16px 8px 16px;
}
.iconfont {
  color: #bcc2cc;
  font-weight: bold;
}
</style>
